import React from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import { compose, withState, withHandlers } from 'recompose';
import { ui, forms } from 'components';
import apiHOCs from 'components/apiHOCs';

import 'assets/screens.scss';
import './style.scss';

const CheckoutScene = ({
  ordersApiHOC: {
    postOrder,
    orderNumber,
  },
  option,
  setOption,
  isModalOpen,
  setModalOpen,
  removeCart,
  formatDataAndPostOrder,
  history: {
    replace,
  },
}) => (
	<div className="checkout-layout">
    <h1 className="checkout-layout__caption">Выберите способ доставки</h1>
    <div className="checkout-layout__buttons">
      <ui.Buttons.RadioButton
        title="Самовывоз"
        isChecked={option === 1}
        onClick={() => setOption(1)}
      />
      {
        option === 1 && <forms.SelfPickUpForm
          submitAction={formatDataAndPostOrder}
          onSubmitSuccess={() => {
            removeCart();
            setModalOpen(true);
          }}
        />
      }
      {/*<ui.Buttons.RadioButton*/}
        {/*title="Служба доставки СДЭК"*/}
        {/*isChecked={option === 2}*/}
        {/*onClick={() => setOption(2)}*/}
      {/*/>*/}
      <ui.Buttons.RadioButton
        title="Транспортной компанией по вашему выбору"
        isChecked={option === 3}
        onClick={() => setOption(3)}
      />
      {
        option === 3 && <forms.DeliveryServiceForm
          submitAction={postOrder}
          onSubmitSuccess={() => {
            removeCart();
            setModalOpen(true);
          }}
        />
      }
      <Modal
        isOpen={isModalOpen}
        onRequestClose={() => replace('/')}
        ariaHideApp={false}
        style={{
          overlay: {
            zIndex: 1005,
            backgroundColor: 'rgba(0,0,0,0.5)',
          },
          content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            padding: '20px',
            overflow: 'none',
          },
        }}
      >
        <div className="checkout-layout__modal-success">
          <span>Ваш заказ принят, номер заказа {orderNumber}</span>
          <span>На указанный e-mail направлена информация с подробностями заказа.</span>
          <span>В ближайшее время с Вами свяжется менеджер.</span>
          <span>Спасибо, что выбрали нас!</span>
          <ui.Buttons.BaseButton
            style={{
              marginTop: '10px',
              width: '35px',
              alignSelf: 'center',
            }}
            title="OK"
            onClick={() => replace('/')}
          />
        </div>
      </Modal>
    </div>
	</div>
);

CheckoutScene.propTypes = {
  option: PropTypes.number.isRequired,
  setOption: PropTypes.func.isRequired,
  isModalOpen: PropTypes.bool.isRequired,
  setModalOpen: PropTypes.func.isRequired,
  removeCart: PropTypes.func.isRequired,
  formatDataAndPostOrder: PropTypes.func.isRequired,

  history: PropTypes.shape({
    replace: PropTypes.func.isRequired,
  }).isRequired,

  ordersApiHOC: PropTypes.shape({
    postOrder: PropTypes.func.isRequired,
  }).isRequired,
};

export default compose(
  withState('option', 'setOption', -1),
  withState('isModalOpen', 'setModalOpen', false),
  apiHOCs.OrdersApiHOC(),
  apiHOCs.ProductsListApiHOC(),

  withHandlers({
    formatDataAndPostOrder: ({
      cart,
      ordersApiHOC: { postOrder },
      productsListApiHOC: { products },
    }) => (data) => {
      const requestData = { sum: cart.sum, products: [], ...data };

      Object.entries(cart).map((prop) => {
        if (prop[0] !== 'quantity' && prop[0] !== 'sum' && prop[1] !== undefined) {
          const fullProduct = products.find(product => product.id === prop[1].id);
          requestData.products.push({
            name: fullProduct.name,
            code: fullProduct.code,
            price: fullProduct.price,
            size: fullProduct.properties.size.find(item => item.id === prop[1].size).name,
            color: fullProduct.properties.color.find(item => item.id === prop[1].color).name,
            count: prop[1].count,
            sum: prop[1].count * fullProduct.price,
          });
        }
      });

      return postOrder(requestData);
    },
  }),
)(CheckoutScene);



// WEBPACK FOOTER //
// ./src/scenes/CheckoutScene/index.js